import { useEffect, useState } from 'react';
import { getCountries } from '../../../redux/api/utils';

export const useCountries = () => {
    const [countries, setCountries] = useState([]);
    const [loadingCountries, setLoadingCountries] = useState(false);
    const [errorCountries, setErrorCountries] = useState(null);

    useEffect(() => {
        const fetchCountries = async () => {
            setLoadingCountries(true);
            try {
                const request = await getCountries();
                if (request.data.response_data.error) {
                    throw new Error(request.data.response_data.error);
                }
                setCountries(request.data.response_data);
            } catch (error) {
                setErrorCountries(error);
            } finally {
                setLoadingCountries(false);
            }
        };
        fetchCountries();
    }, []);

    return { countries, loadingCountries, errorCountries };
};
